import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// material
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';
// components
import { FunctionComponent } from 'react';
import _401 from 'assets/images/401.jpg';

// Customization state
import { openMenu } from 'config/customization';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
	display: 'flex',
	minHeight: '100%',
	alignItems: 'center',
	paddingTop: theme.spacing(15),
	paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

const NotFound: FunctionComponent = () => {
	const distpatch = useDispatch();

	return (
		<RootStyle title='Access Denied'>
			<Container>
				<Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
					<motion.div>
						<Box
							component='img'
							src={_401}
							sx={{
								height: 450,
								mx: 'auto',
								my: { xs: 5, sm: 10 },
							}}
						/>
					</motion.div>
					<motion.div>
						<Typography variant='h3' paragraph>
							Sorry, you can't access this page!
						</Typography>
					</motion.div>

					<Button
						to='/dashboard'
						onClick={() => distpatch(openMenu({ id: 'util-dashboard' }))}
						size='large'
						variant='contained'
						component={RouterLink}
					>
						Go back
					</Button>
				</Box>
			</Container>
		</RootStyle>
	);
};

export default NotFound;
